import styled from 'styled-components'
import { Box } from '../components/box'
import { Text } from '../components/text'

const StyledFooter = styled.footer`
    @media print {
        display: none;
    }
`

export const Footer = () => <StyledFooter>
    <Box>
        <Text color="main" style={{ fontSize: '.7em', marginTop: '6em' }}>
            This site was built with React, Styled Components and Markdown @2025
        </Text>
    </Box>
</StyledFooter>
